import PropTypes from 'prop-types';
import React from 'react';

import './page-size.scss';

class PageSize extends React.Component {
  changeFilter(name, value, event) {
    event.preventDefault();
    this.props.changeFilter(name, value);
  }

  render() {
    const sizeOptions = this.props.sizeOptions.map(function (option, index) {
      return (
        <a href="#"
          onClick={this.changeFilter.bind(this, 'resultsPerPage', option)}
          className={this.props.resultState.filter.resultsPerPage === option ? 'active' : null}
          key={index}
          >
          {option}
        </a>
      );
    }.bind(this));
    return (
      <div className="action-symbols per-page-toggle hidden-xs">
        <span >View</span>
        {sizeOptions}
        &nbsp;
        per page
        /<br className="visible-xs-block" />
        &nbsp;
        <span>Displaying</span>
        &nbsp;
        <b>{this.props.resultState.startCount}-{this.props.resultState.endCount}</b>
        &nbsp;
        of
        &nbsp;
        {this.props.resultState.resultCount}
      </div>
    );
  }
}

PageSize.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  resultState: PropTypes.object.isRequired,
  sizeOptions: PropTypes.array.isRequired
};

export default PageSize;


// WEBPACK FOOTER //
// ./src/components/search/page-size/page-size.js